import React, { memo } from "react";

import { ReactComponent as BlueVehicle } from "../../assets/blueVehicle.svg";
import { ReactComponent as GrayVehicle } from "../../assets/grayVehicle.svg";
import { ReactComponent as OrangeVehicle } from "../../assets/orangeVehicle.svg";
import { ReactComponent as RedVehicle } from "../../assets/redVehicle.svg";
import { ReactComponent as YellowVehicle } from "../../assets/yellowVehicle.svg";

interface VehicleIconInterface {
  vbStatus: string | null;
  webstate: string | null;
  isHovered?: boolean;
  isFocused?: boolean;
  onlineStatus?: string | null;
  hasLiveTelemetry?: boolean;
}

const ICONS_DICT: { [key: string]: JSX.Element } = {
  AVAILABLE: <BlueVehicle />,
  UNAVAILABLE: <OrangeVehicle />,
  REMOTE_CONTROL: <BlueVehicle />,
  RUNNING_MISSION: <BlueVehicle />,
  CALL_FOR_TELEOP: <RedVehicle />,
  CALL_FOR_TECHNICIAN: <OrangeVehicle />,
};

export const VehicleIcon = memo(
  ({
    vbStatus,
    webstate,
    isHovered,
    isFocused,
    onlineStatus,
    hasLiveTelemetry,
  }: VehicleIconInterface) => {
    const webstateKey = webstate?.toUpperCase() || "";

    // Visual priority: focused > hovered > default
    const iconStyle: React.CSSProperties = {
      filter: isFocused
        ? "drop-shadow(0 0 8px rgba(37, 63, 115, 0.9))"
        : isHovered
        ? "drop-shadow(0 0 6px rgba(37, 63, 115, 0.6))"
        : "none",
      transform: isFocused
        ? "scale(1.2)"
        : isHovered
        ? "scale(1.1)"
        : "scale(1)",
      transition: "all 0.3s ease",
      opacity: isFocused ? 1 : 0.9,
    };

    // Grey out offline vehicles — but trust live telemetry over the heartbeat tracker.
    // The amqp-to-cloud-core-processor is the only thing that writes ONLINE to Redis;
    // if it's down, every vehicle reads OFFLINE even while actively sending telemetry.
    if (onlineStatus?.toUpperCase() === "OFFLINE" && !hasLiveTelemetry) {
      return (
        <div style={iconStyle}>
          <GrayVehicle />
        </div>
      );
    }

    let icon;
    if (vbStatus?.toUpperCase() === "OVERRIDE") {
      icon = <YellowVehicle />;
    } else {
      icon = ICONS_DICT[webstateKey] || <GrayVehicle />;
    }

    return <div style={iconStyle}>{icon}</div>;
  }
);
